<div class="card">
  <h3 mat-dialog-title>{{ 'common.snapAi' | t }}</h3>
  <mat-progress-bar *ngIf="isLoading" color="accent" mode="indeterminate"> </mat-progress-bar>
  <p mat-dialog-content *ngIf="!response && !isLoading && !failedSnapAiImage">
    {{ 'map.snapAiSelector.uploadDescription' | t }}
  </p>
  <p mat-dialog-content *ngIf="response && !isLoading">
    {{ 'map.snapAiSelector.selectSubjectDescription' | t }}
  </p>
  <p mat-dialog-content *ngIf="!response && !isLoading && failedSnapAiImage">
    {{ 'map.snapAiSelector.uploadFailedMessage' | t }}
  </p>
  <div
    class="fs-container"
    mat-dialog-content
    *ngIf="(!response && !isLoading && !failedSnapAiImage) || (response && !isLoading)"
  >
    <div class="fs-row">
      <div class="fs-col">
        <mat-progress-bar *ngIf="isLoading" color="accent" mode="indeterminate"> </mat-progress-bar>
        <sn-form *ngIf="!response && !isLoading" [form]="form" [fields]="formFields"></sn-form>

        <fs-ai-boxes
          *ngIf="response"
          (clickItem)="previewItem($event)"
          (select)="select($event)"
          [detections]="response.detection.detections"
          [resolution]="response.detection.resolution"
        >
          <img class="previewImg" [src]="sanitizeImg(dataUrl)" />
        </fs-ai-boxes>
      </div>
      <div class="fs-col">
        <mat-card class="hovered-item" *ngIf="item">
          <mat-card-content>
            <mat-card-title>{{ transform(item.label) }}</mat-card-title>
            <mat-card-subtitle>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.confidence"
                [matTooltip]="(item.confidence | fsNumber : '1.0-2') + '%'"
              ></mat-progress-bar>
            </mat-card-subtitle>
          </mat-card-content>
          <mat-card-content>
            <div class="att" *ngFor="let att of item.metadata?.attributes">
              <strong>{{ transform(att.label) }}</strong>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="att.confidence"
                [matTooltip]="(att.confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.colorTop">
              <strong>{{ 'map.snapAiSelector.colorTop' | t }}</strong>
              <div
                class="color-swatch"
                [matTooltip]="item.metadata?.colorTop.label"
                [style.background-color]="item.metadata?.colorTop.label"
              ></div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.colorTop.confidence"
                [matTooltip]="(item.metadata?.colorTop.confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.colorBottom">
              <strong>{{ 'map.snapAiSelector.colorBottom' | t }}</strong>
              <div
                class="color-swatch"
                [matTooltip]="item.metadata?.colorBottom.label"
                [style.background-color]="item.metadata?.colorBottom.label"
              ></div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.colorBottom.confidence"
                [matTooltip]="(item.metadata?.colorBottom.confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.carColor">
              <strong>{{ 'map.snapAiSelector.carColor' | t }}</strong>
              <div
                class="color-swatch"
                [matTooltip]="item.metadata?.carColor.label"
                [style.background-color]="item.metadata?.carColor[0].label"
              ></div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.carColor[0].confidence"
                [matTooltip]="(item.metadata?.carColor[0].confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.vehicleType">
              <strong>{{ 'map.snapAiSelector.vehicleType' | t }} {{ item.metadata?.vehicleType[0].label }}</strong>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.vehicleType[0].confidence"
                [matTooltip]="(item.metadata?.vehicleType[0].confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <mat-card-actions>
              <button mat-button (click)="createArray()" color="success">{{ 'map.snapAiSelector.createSentry' | t }}</button>
              <button mat-button (click)="searchResults()" color="success">{{ 'common.viewResults' | t }}</button>
            </mat-card-actions>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  <sn-empty-state
    icon="cancel_presentation"
    style="padding: 20px 0"
    *ngIf="!response && !isLoading && failedSnapAiImage"
  >
  </sn-empty-state>
</div>
<mat-dialog-actions align="start">
  <button mat-button *ngIf="response" color="success" (click)="resetSearch()">{{ "common.resetSearch" | t }}</button>
  <button mat-button color="danger" mat-dialog-close="close">{{ "common.cancel" | t }}</button>
</mat-dialog-actions>
